/** Rotating round-robin ensures every saved folder contributes before one can dominate. */
export const selectFactoryStyleReferences = <T extends { folderId: string }>(sources: readonly T[], max = 14, offset = 0): T[] => {
  if (!Number.isInteger(max) || max < 1 || sources.length <= max) return [...sources];
  const groups = new Map<string, T[]>();
  for (const source of sources) groups.set(source.folderId, [...(groups.get(source.folderId) ?? []), source]);
  const roundRobin: T[] = [];
  const largestGroup = Math.max(...Array.from(groups.values(), (group) => group.length));
  for (let index = 0; index < largestGroup; index += 1) {
    for (const group of groups.values()) {
      const source = group[index];
      if (source) roundRobin.push(source);
    }
  }
  const start = Math.abs(Math.trunc(offset)) % roundRobin.length;
  return Array.from({ length: Math.min(max, roundRobin.length) }, (_, index) => (
    roundRobin[(start + index) % roundRobin.length]!
  ));
};
